import * as lib from '../lib'
import { IAccountToken, IFetchPing, Part } from '../types'

export const pingPong = async (
	seq: number,
	msg: string = 'ping',
	signal: AbortSignal,
	tokens?: Part<IAccountToken, "access" | "refresh"> | null,
): Promise<IFetchPing | null> => {
	const access = tokens?.access ?? null

	const headers = lib.bearer(access)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = { seq, msg }
	const uri: string = 'ping'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchPing>(uri, options)

	return data
}
